import { createAction, createReducer } from 'redux-act';
import { API_INSTANCE } from '../../utils/service-http';
import { getAppLocale } from '../../utils/app-locale';
import { api_base_url } from '../../constants';
import ProductInformationCache from '../../persistence/description-cache';
import { appConfiguration } from '../../utils/app-starter';

const DEFAULT_STATE_ACCESSORIES = {
  references: [],
  isLoading: false
}

const getPowerSuppliesStarted = createAction('GET_POWER_SUPPLIES_STARTED');
const getPowerSuppliesSuccess = createAction('GET_POWER_SUPPLIES_SUCCESS');
const getPowerSuppliesFailed = createAction('GET_POWER_SUPPLIES_FAILED');


export const powerSuppliesReducer = createReducer(function (on, off) {
  on(getPowerSuppliesStarted, (state, payload) => {
    return {
      ...state,
      references: [],
      isLoading: true
    };
  });
  on(getPowerSuppliesSuccess, (state, payload) => {
    return {
      ...state,
      references: payload,
      isLoading: false
    };
  });
  on(getPowerSuppliesFailed, (state, payload) => {
    return {
      ...state,
      references: [],
      isLoading: false
    };
  });
}, DEFAULT_STATE_ACCESSORIES);


function buildPowerSuppliesURL() {
  return `${api_base_url}/compatible-power-supplies?locale=${getAppLocale()}`;
}

export function getPowerSupplies(criteria, powerSupplyGroups) {
  return async dispatch => {
    dispatch(getPowerSuppliesStarted());
    return API_INSTANCE.post(buildPowerSuppliesURL(), {
      criteria,
      powerSupplyGroups
    })
      .then((result) => {
        dispatch(getPowerSuppliesSuccess(result.data.payload.powerSupplies));
        ProductInformationCache.loadReferencesDescriptions([...result.data.payload.powerSupplies.filter(x => x != null)]);
        return result.data.payload.powerSupplies;
      })
      .catch((error) => {
        dispatch(getPowerSuppliesFailed([]));
        throw error;
      })
  };
}

/**
 * No redux side effect for this function, as we will only get the list of remaining criteria.
 *
 * @param {*} criteria
 * @returns
 */
export const getPowerSuppliesForRequirements = (criteria) => {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';
  return async dispatch => {
    dispatch(getPowerSuppliesStarted());

    return API_INSTANCE.post(`${api_base_url}/power-supplies?locale=${getAppLocale()}${mainOverrideString}`,
      {
        criteria: { ...criteria, },
        distributorUnscoping: appConfiguration.distributorUnscoping
      })
      .then((success) => {
        dispatch(getPowerSuppliesSuccess([]));
        return success.data.payload;
      }).catch((error) => {
        dispatch(getPowerSuppliesFailed());
        throw error;
      });
  }
}
